import graphql from './graphql';

const mutation = /* GraphQL */ `
  mutation Course_singleUpdate($courseObject: CourseObject) {
    Course_singleUpdate(courseObject: $courseObject) {
      value
    }
  }
`;

const courseSingleUpdate = async courseObject => {
  graphql(mutation, { courseObject })
    .then(data => data.Course_singleUpdate)
    .catch(e => e);
};

export default courseSingleUpdate;
